import { Container, Table, Row, Col, Modal } from "react-bootstrap";
import { API_URL } from "../App";
import VN from "../components/VN";
import { useState, useEffect, useContext } from "react";
import { UserDataContext } from "../components/UserDataContext";
import axios from "axios";
import "../components/button.css";
import Button from "@mui/material/Button";
import {
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
import { theme } from "../components/theme";
import Alerts from "../components/Alerts";
import AddIcon from "@mui/icons-material/Add";
import Dropzone from "react-dropzone";
import { apiRequest } from "../components/Config";
import { marginTop, marginBottom } from "../App";
import { useNavigate } from "react-router-dom";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFnsV3";
import { addDays, isAfter, format } from "date-fns";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { pl } from "date-fns/locale";
import { Formik, Form as FormikForm, Field } from "formik";
import * as Yup from "yup";
import LockIcon from "@mui/icons-material/Lock";

const validationSchema = Yup.object().shape({
  file: Yup.mixed().required("Plik jest wymagany"),
  company: Yup.string().required("Firma jest wymagana"),
  project: Yup.string().required("Projekt jest wymagany"),
  docType: Yup.string().required("Typ dokumentu jest wymagany"),
  filecategory: Yup.string().required("Kategoria dokumentu jest wymagana"),
  register: Yup.string().required("Rejestr dokumentu jest wymagany"),
  dateofreceipt: Yup.date().nullable().required("Data wpływu jest wymagana"),
  // dateofissue: Yup.date().nullable().required("Data wystawienia jest wymagana"),
  // datedelivery: Yup.date().nullable().required("Data dostawy jest wymagana"),
  // datepayment: Yup.date().nullable().required("Termin płatności jest wymagany"),
  // description: Yup.string().nullable(),
});

export default function FilesData() {
  const { userData } = useContext(UserDataContext);
  const [data, setData] = useState([]);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const [text, setText] = useState("Pobieranie danych...");
  const [textAddFile, setTextAddFile] = useState("Dodaj dokument");
  const [apiResponse, setApiResponse] = useState({});
  const [showApiResponse, setShowApiResponse] = useState(false);
  const [showAddFile, setShowAddFile] = useState(false);
  const [showFiles, setShowFiles] = useState(true);
  const [status, setStatus] = useState(0);
  const [typesAll, setTypesAll] = useState([]);
  const [categoryAll, setCategoryAll] = useState([]);
  const [registerAll, setRegisterAll] = useState([]);
  const [selectedFile, setSelectedFile] = useState(null);
  const navigate = useNavigate();
  const [companies, setCompanies] = useState([]);
  const [companyChoose, setCompanyChoose] = useState(0);
  const [projects, setProjects] = useState([]);
  const [amounts, setAmounts] = useState({
    net: "",
    vat: "",
    gross: "",
  });

  const handleAmountChange = (field, value) => {
    const numValue = parseFloat(value) || 0;
    const newAmounts = {
      ...amounts,
      [field]: numValue,
    };
    newAmounts.gross = newAmounts.net + newAmounts.vat;
    setAmounts(newAmounts);
  };

  const font = { fontSize: "0.85rem", fontFamily: "Arial" };

  useEffect(() => {
    const fetchData = async () => {
      if (!userData) return;
      try {
        const response = await apiRequest(`files/` + companyChoose, "GET");
        setData(response);
        if (response.length === 0) setText("Brak dokumentów...");
        setStatus(response.status);
      } catch (error) {
        setError(error.message);
      }
    };
    let interval;
    if (userData && userData.userId) {
      fetchData();
      interval = setInterval(fetchData, 10000);
    }
    return () => clearInterval(interval);
  }, [userData, companyChoose]);

  useEffect(() => {
    const fetchAll = async () => {
      try {
        setTypesAll(await apiRequest("filestypes"));
        setCategoryAll(await apiRequest("filescategory"));
        setRegisterAll(await apiRequest("filesregister"));
        setCompanies(await apiRequest("companies"));
        setProjects(await apiRequest("filesprojects"));
      } catch (error) {
        console.log(error.message);
      }
    };
    if (userData && userData.userId) fetchAll();
  }, [userData]);

  const onDrop = (acceptedFiles) => {
    if (acceptedFiles.length > 0) setSelectedFile(acceptedFiles[0]);
  };

  const handleUpload = async (values, { setSubmitting }) => {
    //console.log("handleUpload called", values, selectedFile);

    try {
      /*
      if (!selectedFile) {
        setApiResponse({
          title: "Informacja",
          severity: "warning",
          info: "Musisz wybrać dokument do załadowania.",
        });
        setShowApiResponse(true);
        return;
      }
        */
      const fd = new FormData();
      fd.append("file", selectedFile);
      fd.append("userId", userData.userId);
      fd.append("company", companyChoose);
      Object.entries(values).forEach(([key, val]) => {
        fd.append(key, val || "");
      });

      values.net = amounts.net;
      values.gross = amounts.gross;
      values.vat = amounts.vat;
      console.log("ValuesUpload: ", values);

      const response = await axios.post(`${API_URL}/upload`, fd, {
        headers: { "Content-Type": "multipart/form-data" },
        withCredentials: true,
        maxContentLength: Infinity,
        maxBodyLength: Infinity,
      });
      console.log("uplod response: ", response);
      if (response.data.fileId > 0) {
        setApiResponse({
          title: "Informacja",
          severity: "success",
          info: "Plik został poprawnie załadowany.",
        });
        setShowApiResponse(true);
        setSelectedFile(null);
      } else {
        setApiResponse({
          title: "Informacja",
          severity: "warning",
          info: "Wystąpił błąd podczas importu pliku.",
        });
        setShowApiResponse(true);
      }
    } catch (error) {
      console.error("Błąd: ", error.status);
      setApiResponse({
        title: "Informacja",
        severity: "warning",
        info: "Nieznany błąd podczas importu pliku. Zgłoś problem Administratorowi. Prawdopodobna przyczyna: plik o takiej nazwie jest już w systemie.",
      });
      setShowApiResponse(true);
    } finally {
      setSubmitting(false);
    }

    setSubmitting(false);
  };

  const initialValues = {
    file: null,
    company: "",
    project: "",
    docType: "",
    filecategory: "",
    register: "",
    dateofreceipt: "",
    dateofissue: "",
    datedelivery: "",
    datepayment: "",
    net: "",
    vat: "",
    gross: "",
    remainingpaid: "",
    description: "",
  };

  const handleShowAddFile = () => {
    setShowAddFile(!showAddFile);
    setShowFiles(!showFiles);
    setTextAddFile(showFiles ? "Zamknij" : "Dodaj dokument");
    setShowApiResponse(false);
  };

  useEffect(() => {
    if (showApiResponse) {
      const timer = setTimeout(() => {
        setShowApiResponse(false);
      }, 3000);
      return () => clearTimeout(timer); // cleanup gdy komponent się odmontuje
    }
    setShowAddFile(false);
    setShowFiles(true);
    setTextAddFile("Dodaj dokument");
  }, [showApiResponse]);

  return (
    <div>
      <VN userData={userData} />
      <ThemeProvider theme={theme}>
        {showApiResponse && (
          <Row>
            <Alerts data={apiResponse} />
          </Row>
        )}

        {showFiles && (
          <>
            <Row style={{ marginTop }}>
              <Col md="2">
                <Button
                  onClick={handleShowAddFile}
                  style={{ marginTop: "0px" }}
                >
                  {textAddFile}
                  <AddIcon />
                </Button>
              </Col>
              <Col md="6" style={{ marginBottom }}>
                {/*<InputLabel id="filesCompany-label">Firma</InputLabel>*/}
                <Select
                  labelId="filesCompany-label"
                  id="company"
                  name="company"
                  value={companyChoose}
                  onChange={(e) => setCompanyChoose(e.target.value)}
                  fullWidth
                  size="small"
                  sx={font}
                >
                  <MenuItem key="0" value="0" sx={font}>
                    -- WSZYSTKIE FIRMY --
                  </MenuItem>
                  {companies.map((item) => (
                    <MenuItem key={item.id} value={item.id} sx={font}>
                      {item.company}
                    </MenuItem>
                  ))}
                </Select>
              </Col>
            </Row>

            <Table bordered hover>
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Firma</th>
                  <th>Plik</th>
                  <th>Projekt</th>
                  <th>Typ</th>
                  <th>Kategoria</th>
                  <th>Data utworzenia</th>
                  <th>Dodał</th>
                  <th>Opis</th>
                </tr>
              </thead>
              <tbody>
                {/* onClick={() =>window.open(`/fileedit/${item.id}`, "_blank")} */}

                {data && data.length > 0 ? (
                  data.map((item, index) => (
                    <tr key={index}>
                      <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                      <td>{item.companyName}</td>
                      <td>
                        <a
                          href={`/fileedit/${item.id}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          onClick={(e) => {
                            e.preventDefault(); // blokuje domyślne przeładowanie
                            window.open(`/fileedit/${item.id}`, "_blank");
                          }}
                        >
                          {item.fileoriginal}
                        </a>
                      </td>
                      <td>{item.project}</td>
                      <td>{item.type}</td>
                      <td>{item.category}</td>
                      <td>{item.created}</td>
                      <td>{item.createdBy}</td>
                      <td>{item.description}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="10" style={{ textAlign: "center" }}>
                      <p>{text}</p>
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </>
        )}

        {showAddFile && (
          <Formik
            initialValues={initialValues}
            //validationSchema={validationSchema}
            validationSchema={null}
            onSubmit={(values, formikHelpers) => {
              console.log("Formik onSubmit fired: ", values);
              handleUpload(values, formikHelpers);
            }}
          >
            {({
              values,
              setFieldValue,
              isSubmitting,
              errors,
              touched,
              setFieldTouched,
            }) => {
              //console.log("Errors:", errors);
              //console.log("Values:", values);
              return (
                <FormikForm>
                  <Dropzone
                    onDrop={(acceptedFiles) => {
                      setFieldValue("file", acceptedFiles[0]);
                      setFieldTouched("file", true);
                    }}
                    multiple={false}
                  >
                    {({ getRootProps, getInputProps }) => (
                      <div
                        {...getRootProps()}
                        style={{
                          border: "2px dashed #4a6587",
                          padding: "30px",
                          cursor: "pointer",
                        }}
                      >
                        <input {...getInputProps()} />
                        <p>
                          Przeciągnij i upuść dokument tutaj lub kliknij, aby
                          wybrać dokument z dysku.
                        </p>

                        {/* sprawdzamy czy plik jest w formiku */}
                        {values.file && <p>Wybrano: {values.file.name}</p>}
                      </div>
                    )}
                  </Dropzone>
                  {errors.file && touched.file && (
                    <div style={{ color: "red" }}> {errors.file}</div>
                  )}
                  {/* komunikat walidacji */}

                  <Row style={{ marginTop }}>
                    {userData &&
                      (userData.permId === "1" || userData.permId === "3") && (
                        <Col md="9">
                          <Field name="company">
                            {({ field, meta }) => (
                              <FormControl fullWidth>
                                <InputLabel id="company-label">
                                  Firma
                                </InputLabel>
                                <Select
                                  {...field}
                                  labelId="company-label"
                                  value={field.value}
                                  variant="standard"
                                  onChange={(e) => {
                                    field.onChange(e);
                                    setFieldValue("company", e.target.value);
                                  }}
                                >
                                  {companies.map((item) => (
                                    <MenuItem key={item.id} value={item.id}>
                                      {item.company}
                                    </MenuItem>
                                  ))}
                                </Select>
                                {meta.touched && meta.error && (
                                  <div
                                    style={{ color: "red", fontSize: "0.8rem" }}
                                  >
                                    {meta.error}
                                  </div>
                                )}
                              </FormControl>
                            )}
                          </Field>
                        </Col>
                      )}
                    {userData &&
                      (userData.permId === "1" || userData.permId === "3") && (
                        <Col md="3">
                          <Field name="project">
                            {({ field, meta }) => (
                              <FormControl fullWidth>
                                <InputLabel id="project-label">
                                  Projekt
                                </InputLabel>
                                <Select
                                  {...field}
                                  labelId="project-label"
                                  value={field.value}
                                  variant="standard"
                                  onChange={(e) => {
                                    field.onChange(e);
                                    setFieldValue("project", e.target.value);
                                  }}
                                >
                                  {projects.map((item) => (
                                    <MenuItem key={item.id} value={item.id}>
                                      {item.project}
                                    </MenuItem>
                                  ))}
                                </Select>
                                {meta.touched && meta.error && (
                                  <div
                                    style={{ color: "red", fontSize: "0.8rem" }}
                                  >
                                    {meta.error}
                                  </div>
                                )}
                              </FormControl>
                            )}
                          </Field>
                        </Col>
                      )}
                  </Row>
                  <Row style={{ marginTop }}>
                    <Col md="3">
                      <Field name="docType">
                        {({ field, meta }) => (
                          <FormControl fullWidth>
                            <InputLabel id="docType-label">
                              Typ dokumentu
                            </InputLabel>
                            <Select
                              {...field}
                              labelId="docType-label"
                              value={field.value}
                              variant="standard"
                              onChange={(e) => {
                                field.onChange(e);
                                setFieldValue("docType", e.target.value);
                              }}
                            >
                              {typesAll.map((item) => (
                                <MenuItem key={item.id} value={item.id}>
                                  {item.type}
                                </MenuItem>
                              ))}
                            </Select>
                            {meta.touched && meta.error && (
                              <div style={{ color: "red", fontSize: "0.8rem" }}>
                                {meta.error}
                              </div>
                            )}
                          </FormControl>
                        )}
                      </Field>
                    </Col>
                    <Col md="3">
                      <Field name="filecategory">
                        {({ field, meta }) => (
                          <FormControl fullWidth>
                            <InputLabel id="docType-label">
                              Kategoria
                            </InputLabel>
                            <Select
                              {...field}
                              labelId="category-label"
                              value={field.value}
                              variant="standard"
                              onChange={(e) => {
                                field.onChange(e);
                                setFieldValue("category", e.target.value);
                              }}
                            >
                              {categoryAll.map((item) => (
                                <MenuItem key={item.id} value={item.id}>
                                  {item.category}
                                </MenuItem>
                              ))}
                            </Select>
                            {meta.touched && meta.error && (
                              <div style={{ color: "red", fontSize: "0.8rem" }}>
                                {meta.error}
                              </div>
                            )}
                          </FormControl>
                        )}
                      </Field>
                    </Col>
                    <Col md="3">
                      <Field name="register">
                        {({ field, meta }) => (
                          <FormControl fullWidth>
                            <InputLabel id="register-label">Rejestr</InputLabel>
                            <Select
                              {...field}
                              labelId="register-label"
                              value={field.value}
                              variant="standard"
                              onChange={(e) => {
                                field.onChange(e);
                                setFieldValue("register", e.target.value);
                              }}
                            >
                              {registerAll.map((item) => (
                                <MenuItem key={item.id} value={item.id}>
                                  {item.register}
                                </MenuItem>
                              ))}
                            </Select>
                            {meta.touched && meta.error && (
                              <div style={{ color: "red", fontSize: "0.8rem" }}>
                                {meta.error}
                              </div>
                            )}
                          </FormControl>
                        )}
                      </Field>
                    </Col>
                  </Row>
                  <Row style={{ marginTop }}>
                    {[
                      "dateofreceipt",
                      "dateofissue",
                      "datedelivery",
                      "datepayment",
                    ].map((field, idx) => (
                      <Col md="3" key={field}>
                        <LocalizationProvider
                          dateAdapter={AdapterDateFns}
                          adapterLocale={pl}
                        >
                          <DatePicker
                            label={
                              field === "dateofreceipt"
                                ? "Data wpływu"
                                : field === "dateofissue"
                                ? "Data wystawienia"
                                : field === "datedelivery"
                                ? "Data dostawy"
                                : "Termin płatności"
                            }
                            value={
                              values[field] ? new Date(values[field]) : null
                            }
                            onChange={(newValue) =>
                              setFieldValue(
                                field,
                                newValue ? format(newValue, "yyyy-MM-dd") : ""
                              )
                            }
                            minDate={addDays(new Date(), -90)}
                            format="yyyy-MM-dd"
                            slotProps={{
                              textField: {
                                variant: "standard",
                                fullWidth: true,
                              },
                            }}
                          />
                        </LocalizationProvider>
                      </Col>
                    ))}
                  </Row>
                  <Row style={{ marginTop }}>
                    <Col md="3">
                      <FormControl fullWidth>
                        <Field name="net">
                          {({ field, meta }) => (
                            <TextField
                              {...field}
                              label="Kwota netto"
                              value={amounts.net}
                              onChange={(e) =>
                                handleAmountChange("net", e.target.value)
                              }
                              variant="standard"
                              error={meta.touched && Boolean(meta.error)}
                              helperText={meta.touched && meta.error}
                              type="number"
                            />
                          )}
                        </Field>
                      </FormControl>
                    </Col>
                    <Col md="3">
                      <FormControl fullWidth>
                        <Field name="vat">
                          {({ field, meta }) => (
                            <TextField
                              {...field}
                              label="Kwota vat"
                              value={amounts.vat}
                              onChange={(e) =>
                                handleAmountChange("vat", e.target.value)
                              }
                              variant="standard"
                              error={meta.touched && Boolean(meta.error)}
                              helperText={meta.touched && meta.error}
                              type="number"
                            />
                          )}
                        </Field>
                      </FormControl>
                    </Col>
                    <Col md="3">
                      <FormControl fullWidth>
                        <Field name="gross">
                          {({ field, meta }) => (
                            <TextField
                              {...field}
                              label="Kwota brutto"
                              value={amounts.gross}
                              variant="standard"
                              error={meta.touched && Boolean(meta.error)}
                              helperText={meta.touched && meta.error}
                              type="number"
                              InputProps={{
                                readOnly: true,
                                endAdornment: (
                                  <LockIcon fontSize="small" color="disabled" />
                                ),
                              }}
                            />
                          )}
                        </Field>
                      </FormControl>
                    </Col>
                    <Col md="3">
                      <FormControl fullWidth>
                        <Field name="remainingpaid">
                          {({ field, meta }) => (
                            <TextField
                              {...field}
                              label="Pozostało do zapłaty"
                              variant="standard"
                              error={meta.touched && Boolean(meta.error)}
                              helperText={meta.touched && meta.error}
                              type="number"
                            />
                          )}
                        </Field>
                      </FormControl>
                    </Col>
                  </Row>
                  <Row style={{ marginTop }}>
                    <Col md="6">
                      <TextField
                        fullWidth
                        label="Opis dokumentu"
                        name="description"
                        value={values.description}
                        onChange={(e) =>
                          setFieldValue("description", e.target.value)
                        }
                      />
                    </Col>
                  </Row>
                  <Button
                    type="submit"
                    variant="contained"
                    disabled={isSubmitting}
                    style={{ marginTop: "20px" }}
                  >
                    Wyślij
                  </Button>
                </FormikForm>
              );
            }}
          </Formik>
        )}
      </ThemeProvider>
    </div>
  );
}
